import React from "react";
import styled from "styled-components";

export default styled.h3`
    font-size: 18px;
    font-family: "Proxima-Nova";
    color: #515151;
    margin: 0;
    height: 44px;
    cursor: pointer;
    padding: 10px 15px;
    position: relative;
    margin-left: 5px;
    clear: both;
    
    display: ${(props) => (props.hidden ? "none" : "block")};
    &:hover {
        background: #5562C0;
        border-radius: 20px;
        color: white;
    }
`;